import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({ spacing }: Theme) => ({
  container: {
    display: 'flex',
    flex: '1',
    height: '100%',
    flexDirection: 'column',
    '& > form': {
      flex: '1',
      display: 'flex',
      flexDirection: 'column',
    },
    '& > div': {
      marginBottom: spacing(2)
    }
  },
}));

export default useStyles;
